import axios from 'axios'
import { nanoid } from 'nanoid'
import { apolloClient } from '~/common/apollo'
import { GET_APP_INIT_QUERY } from '~/common/apollo/queries/app.query'
import { captureException } from '~/common/helpers'
import { action, computed, observable, persist, storage, store } from '~/common/mobx.decorator'
import { contactStore } from '~/features/care-contact-us/care-contact-us.store'
import { notifyStore } from '~/stores/notify.store'
import { THEMES } from '~/themes'

axios.defaults.baseURL = `${process.env.REACT_APP_PROXY_API_URL}`
axios.defaults.headers['APP_ID'] = process.env.REACT_APP_PROXY_API_APP_ID
axios.defaults.headers['TENANT-ID'] = process.env.REACT_APP_COMPANY_ID
axios.defaults.headers['APP_SECRET'] = process.env.REACT_APP_PROXY_API_APP_SECRET

axios.interceptors.response.use(undefined, (error) => {
	captureException('Axios Client', error)
	return Promise.reject(error)
})

@store({ persist: true })
class AppStore {
	constructor() {
		storage.ready(() => {
			this.ready = true
			if (!this._uniqueId) {
				this._uniqueId = nanoid()
			}
		})
	}

	@persist @observable _uniqueId
	@observable config = null
	@observable ready = false

	@observable chatIntegrationSetting
	@observable meta_domain
	@observable store_android_url
	@observable store_ios_url

	@observable appInit = {}

	@computed
	get id() {
		// Company Id
		return process.env.REACT_APP_COMPANY_ID
	}

	@computed
	get name() {
		return process.env.REACT_APP_COMPANY_NAME
	}

	@computed
	get logo() {
		return process.env.PUBLIC_URL + `/assets/logo.svg`
	}

	@computed
	get getTheme() {
		return THEMES.candidate
	}

	@action
	init = async () => {
		try {
			await this.fetchFEConfig()
			await this.fetchAppConfig()
			await this.fetchAppInit()
		} catch (e) {
			console.error(e)
		}
	}

	@action
	fetchAppConfig = async () => {
		const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
		if (!isMobile) {
			await notifyStore.initOneSignal().then(() => notifyStore.sendInfo())
		}
	}

	fetchFEConfig = async () => {
		const response = await fetch('/app-config.json')
		const data = await response.json()

		return data
	}

	@action
	fetchAppInit = async () => {
		try {
			const res = await apolloClient.query({
				query: GET_APP_INIT_QUERY,
				context: {
					clientName: 'public',
				},
			})

			const { data } = res || {}
			if (!data) throw new Error('No data')

			const { appInit } = data || {}
			if (!appInit) throw new Error('No appInit')
			this.appInit = appInit

			// Set contact information used for feature `Contact Us`
			const technicalSupportTeam = Array.from(appInit?.tenantContacts || []).find(({ contactType }) => contactType === 'technical') || {}

			contactStore.contactSupportTeam = {
				email: technicalSupportTeam?.email,
			}
		} catch (e) {
			console.error(e)
		}
	}
}

export const appStore = new AppStore()
